import ReactDOM from 'react-dom';
import './index.css';
import ApolloProvider from './ApolloProvider';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'boxicons/css/boxicons.min.css';

ReactDOM.render(ApolloProvider, document.getElementById('root'));
